// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"index_pageTitle_1cfCV","cardTitle":"index_cardTitle_3eYST","filledBtn":"index_filledBtn_scGIP","requiredMark":"index_requiredMark_3jGj2","stripe0":"index_stripe0_3sYwJ","stripe1":"index_stripe1_jlPom","stripe":"index_stripe_1GwkH","companyName":"index_companyName_5lHp7","basicInfoList":"index_basicInfoList_hNxS-","infoLabel":"index_infoLabel_yIg5l","infoValue":"index_infoValue_17VIi","list-name":"index_list-name_1vVUl"};
    if(module.hot) {
      // 1788760850840
      var cssReload = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":true});
      module.hot.dispose(cssReload);
      
    }
  